const commonSwrConfig = (updateSession?: () => void) => {
  return {
    errorRetryInterval: 5000,
    errorRetryCount: 3,
    onError: (err: unknown) => {
      if (err === 401 && updateSession) {
        updateSession();
      }
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onErrorRetry: (error: any, key: string, config: any, revalidate: any, { retryCount }: { retryCount: number }) => {
      // Never retry on 404.
      if (error === 404 || error.status === 404) return;

      // Only retry up to 10 times.
      if (retryCount >= 3) return;

      // Retry after 5 seconds.
      setTimeout(() => revalidate({ retryCount }), 5000);
    },
  };
};

export default commonSwrConfig;
